import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type BrandNodeFragment = { __typename?: 'BrandNode', id: string, name: string };

export const BrandNodeFragmentDoc = gql`
    fragment BrandNode on BrandNode {
  id
  name
}
    `;